import { render, staticRenderFns } from "./HistoricoSazonal.vue?vue&type=template&id=afdf03d6"
import script from "./HistoricoSazonal.vue?vue&type=script&lang=js"
export * from "./HistoricoSazonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports